"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HighLowValue = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _util = require("../../../util");

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The HighLowValue component accepts a numeric `value` prop, which is used to
 * determine the text color for the rendered content, returned in a `Text`
 * component.
 *
 * When the value prop changes, the new value will be compared to the
 * previous one.
 *
 * By default, the value itself is rendered, without any formatting. If you
 * need to render any content aside from the value itself (eg, as a
 * formatted string, or alongside other content), then children may
 * be used to provide renderable content, instead of using the `value` prop.
 */
const HighLowValue = ({
  children,
  ltpChange,
  ...otherProps
}) => {
  const variant = (0, _.useValueChange)(ltpChange);
  const color = (0, _util.getColorForVariant)(variant);
  return (0, _pragma.createFelaElement)(_.Text, _extends({
    color: color,
    children: children || ltpChange
  }, otherProps));
};

exports.HighLowValue = HighLowValue;
HighLowValue.displayName = 'HighLowValue';
var _default = HighLowValue;
exports.default = _default;
//# sourceMappingURL=HighLowValue.js.map